import PropTypes from 'prop-types';
import React, {Component} from 'react';
import {connect} from '~/redux/connect';
import {
    getAllItemStateInfos, getItemData, isDataModelLoaded
} from "~/stateGetter";
import identify from "~/identify";
import cancelToken from "~/data/cancelToken";
import limit from "~/data/limit";
import {fetchItem} from "~/rx/model/fetchItem";
import {modelActionsCreator} from "~/actions/model_actions";
import ModelResultManager from "./ResultManager";
import {presentResultsLoading} from "~/statePresenter";
import { Box } from "~/native-ui"

class InternalItemManager extends Component {
    static propTypes  = {
        // system props
        children: PropTypes.node,
        requestGroup: PropTypes.string,

        itemId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        loadedItemId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    };

    static defaultProps = {
        children: null
    };

    isOutOfSync(prev) {
        let { itemId } = this.props;

        if(!itemId || !itemId.length) { return false; }
        if(this.props.itemDataState.status === identify.STATUS_STARTED) { return false; }
        if(this.props.itemDataState.status === identify.STATUS_ERRORED) { return false; }
        if(this.props.itemDataState.status === identify.STATUS_INVALIDATED) { return true; }

        return itemId !== this.props.loadedItemId;
    }

    loadItem() {
        let { fetchItem, itemId, setNewItem } = this.props;

        if(itemId === identify.NEW_ITEM) {
            return setNewItem();
        }
        limit(this.getRequestGroup(), () => {
        
            // console.log('loadItem', this.props.itemId, this.props.loadedItemId);

            fetchItem(
                cancelToken(this.getRequestGroup())
            );
        });
    }

    componentDidUpdate(prev) {
        if(this.isOutOfSync(prev)) { this.loadItem(); }
    }

    componentDidMount() {
        if(this.isOutOfSync()) {
            this.loadItem();
        }
    }

    getRequestGroup() {
        if(this.props.requestGroup) { return this.props.requestGroup; }
        return identify.modelItemRequestGroup(this.props.modelId, this.props.itemId);
    }

    render() {
        return this.props.children;
    }
}

class ItemManager extends React.Component {
    render() {
        if(!this.props.isDataModelLoaded) { return null; }

        return (
            <Box display="none">
                <ModelResultManager modelId={this.props.modelId} />
                <InternalItemManager {...this.props} />
            </Box>
        )
    }
}

const RXItemManager = connect(
    (state, {modelId}) => {
        let isTheDataModelLoaded = true;//isDataModelLoaded(state, modelId);

        if(!isTheDataModelLoaded) {
            return {
                isDataModelLoaded: isTheDataModelLoaded
            }
        }

        let itemStateInfos = {};

        try {
            itemStateInfos = getAllItemStateInfos(state, modelId);

        } catch(e) {
            throw e;
        }

        return {
            ...itemStateInfos,
            isDataModelLoaded: isDataModelLoaded,
            emptyItemData: getItemData(state, modelId),
        }
    },

    (dispatch, { modelId }) => {
        let { setNewItem } = modelActionsCreator(modelId);

        return {
            fetchItem: () => dispatch(fetchItem(modelId)),
            setNewItem: () => dispatch(setNewItem())
        }
    },

    ({ emptyItemData, ...stateProps }, { setNewItem, ...dispatchProps }, ownProps) => {
        return {
            ...ownProps,
            ...stateProps,
            ...dispatchProps,

            isLoadingResults: presentResultsLoading(stateProps),
            setNewItem: () => setNewItem({...emptyItemData, itemId: identify.NEW_ITEM})
        }
    }
)(ItemManager);

export default RXItemManager;